import { useState, useRef, useEffect } from "react";
import { useThemeColor } from "../../Components/Sidebar/SideBarApi";
import { TeamHeirachyAPI } from "../../API/Api";
import { useSelector } from "react-redux";
import Tree from "react-d3-tree";
import BarLoader from "../../Components/Loader/BarLoader";
import { IconUser } from "@tabler/icons-react";

export default function TreeChart() {
  const themeColor = useThemeColor();
  const treeContainerRef = useRef(null);
  const UserDetails = useSelector((state) => state?.login?.userDetails);
  const [dimensions, setDimensions] = useState({ width: 600, height: 500 });
  const [team, setTeam] = useState({});
  const [lodingSpinner, setLodingSpinner] = useState(true);
  
  const normalizeTreeData = (node) => {
    if (!node) return {};
    return {
      ...node,
      attributes: node.attributes
        ? { ...node.attributes }
        : { role: "No Role" },
        children: node.children?.length
        ? node.children.map(normalizeTreeData)
        : [],
      };
    };
    
    const fetchTeamHeirachy = async (userId) => {
      try {
        setLodingSpinner(true);
        const response = await TeamHeirachyAPI(userId);
        if (response?.status === 200) {
          const normalizedData = normalizeTreeData(
            response?.data?.data?.hierarchy
          );
          setTeam(normalizedData);
          setLodingSpinner(false);
        } else {
          setLodingSpinner(false);
        }
      } catch (err) {
        setLodingSpinner(false);
        console.error("Error in catch:", err);
      }
    };
    
    useEffect(() => {
      if (treeContainerRef.current) {
        const { clientWidth, clientHeight } = treeContainerRef.current;
        setDimensions({ width: clientWidth, height: clientHeight });
      }
      fetchTeamHeirachy(UserDetails?._id);
    }, []);
    
    const renderCustomNodeElement = ({ nodeDatum, toggleNode }) => {
      const hasChildren = nodeDatum.children?.length > 0;
      const nodeColor = hasChildren ? "#05ff8a" : themeColor;
      const textColor = hasChildren ? "#05ff8a" : "#111827";
      
      const name = nodeDatum?.name || "";
    const role = nodeDatum?.attributes?.role || "";
    
    const textLength = Math.max(name.length, role.length);
    
    const cardWidth = 260;
    return (
      <g onClick={toggleNode} style={{ cursor: "pointer" }}>
    <foreignObject
      x={-cardWidth / 2}
      y={-40}
      width={cardWidth}
      height={100}
    >
      <div
        style={{
          width: cardWidth,
          minHeight: 90,
          borderRadius: 14,
          background: "rgb(241 241 242)",
          border: "1px solid #E5E7EB",
          boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
          display: "flex",
          alignItems: "center",
          padding: "10px 14px",
          gap: 12,
          boxSizing: "border-box",
        }}
      >
        {/* Avatar */}
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            background: nodeColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <IconUser stroke={1.5} size={23} color="#fff" variant="Bold" />
        </div>

        {/* Text */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <p
            style={{
              fontSize: 20,
              fontWeight: 900,
              wordBreak: "break-word",
              whiteSpace: "normal",
              lineHeight: "27px",
              color:"#000"
            }}
          >
            {nodeDatum?.name}
          </p>

          <p
            style={{
              fontSize: 16,
              fontWeight:900,
              color: "#000",
              wordBreak: "break-word",
              whiteSpace: "normal",
            }}
          >
            {nodeDatum?.attributes?.role || "No Role"}
          </p>
        </div>
      </div>
    </foreignObject>
  </g>
      // <g onClick={toggleNode} style={{ cursor: "pointer" }}>
      //   {/* Card */}
      //   <rect
      //     x="-125"
      //     y="-45"
      //     width="289"
      //     height="90"
      //     rx="14"
      //     fill="#F3F4F6"
      //     stroke="#e5e7eb"
      //     strokeWidth="1"
      //   />

      //   {/* Avatar Background */}
      //   <circle
      //     cx="-80"
      //     cy="0"
      //     r="22"
      //     fill={nodeColor}
      //     opacity="0.15"
      //   />

      //   <foreignObject x="-94" y="-14" width="28" height="28">
      //     <User  variant="Bold" size="28" color={nodeColor} />
      //   </foreignObject>

      //   {/* Name */}
      //   <text
      //     x="-11"
      //     y="-5"
      //     fontFamily="Inter, sans-serif"
      //     fontSize="19"
      //     fontWeight={100}
      //     fill="#6b7280"
      //   >
      //     {nodeDatum?.name}
      //   </text>

      //   {/* Role */}
      //   <text
      //     x="-11"
      //     y="18"
      //     fontSize="17"
      //     fill="#6b7280"
      //   >
      //     {nodeDatum?.attributes?.role || "No Role"}
      //   </text>
      // </g>
     
    );
  };

  return (
    <div
      ref={treeContainerRef}
      className="w-full h-screen flex items-center justify-center"
    >
      {lodingSpinner ? (
        <BarLoader/>
      ) : (
        <Tree
          data={team}
          translate={{ x: dimensions.width / 2, y: 150 }}
          orientation="vertical"
          collapsible={true}
          draggable={true}
          pathFunc="step"
          separation={{ siblings: 1.5, nonSiblings: 2 }}
          nodeSize={{ x: 250, y: 130 }}
          zoom={0.8}
          renderCustomNodeElement={renderCustomNodeElement}
        />
      )}
    </div>
  );
}
